import { createFileRoute } from "@tanstack/react-router";
import AdminSchemaPage from "@/admin/pages/schema";

export const Route = createFileRoute("/admin/schema")({
  component: AdminSchemaPage,
});
